//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { AuthenticationService } from '../../auth.service';
import { ConfigSystemParams, eSimApiPaths } from 'src/app/core/consts';
import { ConfigSystemService } from '../system/config-system/config-system-service';
import { catchError, distinctUntilChanged, fromEvent, map, Observable, of, startWith, switchMap, throwError } from 'rxjs';
import { EncryptionService } from './encryption-service';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from './exceptions-service';
import { HttpClientService } from './http-client-service';
import { Injectable } from '@angular/core';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { UserClientInfoDTO } from 'src/app/core/models/system/user/user-client-info.dto';

@Injectable({ providedIn: 'root' })

export class ClientInfoService {

  get _getClientInfo() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.SupportGetClientInfo, false); }

  get _navigator(): Navigator                    | undefined { return this._window?.navigator;                            }
  get _window   (): (Window & typeof globalThis) | undefined { return typeof window !== "undefined" ? window : undefined; }
  
  private curUser: SystemUserDTO;

  public hasExecuted: boolean=false;
  
  constructor(
    private authenticationService: AuthenticationService,
    private configSystemService  : ConfigSystemService,
    private encryptionService    : EncryptionService,
    private exceptionsService    : ExceptionsService,
    private httpClientService    : HttpClientService
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  private async getClientInfo(): Promise<UserClientInfoDTO | null> {
    try {
      const _window   =this._window;
      const _navigator=this._navigator;
    
      const userClientInfoDTO: UserClientInfoDTO={
        active                     : true,
        enteredBy                  : this.curUser.userId,
        hardwareDeviceMemory       : (_navigator as any)?.deviceMemory,
        hardwareHardwareConcurrency: _navigator?.hardwareConcurrency,
        hardwareMaxTouchPoints     : (_navigator as any)?.maxTouchPoints,
        screenAvailHeight          : _window?.screen?.availHeight,
        screenAvailWidth           : _window?.screen?.availWidth,
        screenPixelRatio           : _window?.devicePixelRatio,
        screenHeight               : _window?.screen?.height,
        screenWidth                : _window?.screen?.width,
        timeZone                   : this.safeTimeZone(),
        timezoneOffsetMinutes      : new Date().getTimezoneOffset(),
        viewPortInnerHeight        : _window?.innerHeight,
        viewPortInnerWidth         : _window?.innerWidth,
        viewPortOuterHeight        : _window?.outerHeight,
        viewPortOuterWidth         : _window?.outerWidth
      };

      return userClientInfoDTO;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return null;
    }
  }

  private safeTimeZone(): string | undefined {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  public viewport$: Observable<{ width: number; height: number }>=fromEvent(this._window ?? ({} as any), "resize")
    .pipe(
      startWith(null),
      map(() => ({
        width : this._window?.innerWidth ?? 0,
        height: this._window?.innerHeight ?? 0
      })),
      distinctUntilChanged((a, b) => a.width === b.width && a.height === b.height)
    );
  
  public async sendClientInfo() {
    try {
      if (this._getClientInfo && !this.hasExecuted) {
        const userClientInfoDTO: UserClientInfoDTO | null=await this.getClientInfo();
        
        this.post(<UserClientInfoDTO>userClientInfoDTO)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.hasExecuted=true;
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public post(userClientInfo: UserClientInfoDTO): Observable<UserClientInfoDTO> {
    try {
      //JSON.stringify(userClientInfo)
      
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(userClientInfo), true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const userClientInfoEncSS=encResult.result;
                            
                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.UserClientInfo +
                                                               "?objectEncSS=" + userClientInfoEncSS, {}); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
